var _excluded = ["mode", "suffix"],
  _excluded2 = ["mode", "suffix"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { CloseOutlined, DownOutlined } from '@ant-design/icons';
import cx from 'classnames';
import _ from 'lodash';
import React, { useRef, useState } from 'react';
import { useCssInJs, wrapReactionHook, useParams } from "../../hooks";
import { ChoiceModal } from "./components/ChoiceModal";
import { genMultipleChoiceStyles } from "./styles";
import { SelectProvider } from "./useSearchList";
var BatchPicker = function BatchPicker(props) {
  var _props$placeholder, _placeholder;
  var prefix = 'form-batch-picker';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genMultipleChoiceStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var placeholder = '请选择';
  var mode = props.mode,
    suffix = props.suffix,
    readOnly = props.readOnly,
    disabled = props.disabled,
    onChange = props.onChange,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    value = props.value;
  var getParams = useParams(params);
  placeholder = (_props$placeholder = props.placeholder) !== null && _props$placeholder !== void 0 ? _props$placeholder : placeholder;
  var renderValue = Array.isArray(value) ? value : [];
  var isEmpty = renderValue.length === 0;
  var currentLabel = undefined;
  if (!isEmpty) {
    currentLabel = renderValue.slice(0, 100) // 因为太长了会...，所以取前100个就够用了
    .map(function (item) {
      return item === null || item === void 0 ? void 0 : item.label;
    }).join('、');
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var showModal = function showModal() {
    if (disabled) {
      return;
    }
    setIsModalOpen(true);
  };
  var handleOk = function handleOk(values) {
    var _values;
    // 去掉values中的path属性
    values = (_values = values) === null || _values === void 0 ? void 0 : _values.map(function (item) {
      return _.omit(item, 'path');
    });
    onChange === null || onChange === void 0 || onChange(values);
  };
  var handleCancel = function handleCancel() {
    console.log('cancel');
  };
  var stateRef = useRef(null);
  if (readOnly) {
    return wrapSSR( /*#__PURE__*/React.createElement("div", {
      className: cx(hashId, prefix)
    }, /*#__PURE__*/React.createElement("div", {
      className: "readOnly"
    }, currentLabel ? /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, /*#__PURE__*/React.createElement("span", {
      className: "label"
    }, currentLabel), /*#__PURE__*/React.createElement("span", {
      className: "count"
    }, "\u5171", renderValue.length, suffix)) : '-')));
  }
  return wrapSSR( /*#__PURE__*/React.createElement(SelectProvider, _extends({}, props, {
    ref: stateRef,
    filter: getParams()
  }), /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, prefix)
  }, /*#__PURE__*/React.createElement("div", {
    onClick: showModal,
    className: cx('batchPicker', isEmpty ? 'placeholder' : '', disabled ? 'disabled' : '')
  }, currentLabel ? /*#__PURE__*/React.createElement("span", {
    className: "name"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, currentLabel), /*#__PURE__*/React.createElement("span", {
    className: "count"
  }, "\u5171", renderValue.length, suffix)) : (_placeholder = placeholder) !== null && _placeholder !== void 0 ? _placeholder : '请选择', /*#__PURE__*/React.createElement("span", {
    className: "suffix"
  }, isEmpty || disabled ? null : /*#__PURE__*/React.createElement("span", {
    className: "clearButton",
    onClick: function onClick(event) {
      event.stopPropagation();
      onChange && onChange([]);
    }
  }, /*#__PURE__*/React.createElement(CloseOutlined, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "downIcon"
  }, /*#__PURE__*/React.createElement(DownOutlined, null)))), /*#__PURE__*/React.createElement(ChoiceModal, {
    isModalOpen: isModalOpen,
    setIsModalOpen: setIsModalOpen,
    onOk: function onOk(values) {
      handleOk(values);
    },
    onCancel: function onCancel() {
      handleCancel();
    }
  }))));
};
export var BatchUserPicker = wrapReactionHook(function (props) {
  var prefix = 'form-batch-picker-person';
  var _useCssInJs2 = useCssInJs({
      prefix: prefix,
      styleFun: genMultipleChoiceStyles
    }),
    wrapSSR = _useCssInJs2.wrapSSR,
    hashId = _useCssInJs2.hashId;
  var _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'user' : _props$mode,
    _props$suffix = props.suffix,
    suffix = _props$suffix === void 0 ? '人' : _props$suffix,
    rest = _objectWithoutProperties(props, _excluded);
  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, prefix)
  }, /*#__PURE__*/React.createElement(BatchPicker, _extends({
    mode: mode,
    suffix: suffix
  }, rest))));
});
export var BatchStorePicker = wrapReactionHook(function (props) {
  var prefix = 'form-batch-picker-store';
  var _useCssInJs3 = useCssInJs({
      prefix: prefix,
      styleFun: genMultipleChoiceStyles
    }),
    wrapSSR = _useCssInJs3.wrapSSR,
    hashId = _useCssInJs3.hashId;
  var _props$mode2 = props.mode,
    mode = _props$mode2 === void 0 ? 'store' : _props$mode2,
    _props$suffix2 = props.suffix,
    suffix = _props$suffix2 === void 0 ? '家店' : _props$suffix2,
    rest = _objectWithoutProperties(props, _excluded2);
  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, prefix)
  }, /*#__PURE__*/React.createElement(BatchPicker, _extends({
    mode: mode,
    suffix: suffix
  }, rest))));
});